// frontend/src/components/EmailFacturaModal.jsx

import React, { useEffect, useState } from "react";
import "./EmailModal.css";

export default function EmailFacturaModal({
  isOpen,
  onClose,
  factura,
  empresa,
  emailSettings,
  onSend,
}) {
  const [to, setTo] = useState("");
  const [cc, setCc] = useState("");
  const [bcc, setBcc] = useState("");
  const [subject, setSubject] = useState("");
  const [body, setBody] = useState("");

  // 🔵 NUEVO — checkbox incluir IBAN
  const [incluirIBAN, setIncluirIBAN] = useState(false);

  useEffect(() => {
    if (!factura || !emailSettings) return;

    const numero = factura.numero || factura.id;
    const empresaNombre = empresa?.nombre || "Narfran 2020 SL";

    // Email del cliente
    setTo(
      factura.cliente_email ||
        factura.email ||
        factura.cliente?.email ||
        ""
    );

    // ASUNTO (plantilla o defecto)
    let tplSubject =
      emailSettings.asunto_factura ||
      `Factura {{NUMERO}} - ${empresaNombre}`;

    tplSubject = tplSubject
      .replace(/{{NUMERO}}/g, numero)
      .replace(/{{EMPRESA}}/g, empresaNombre);

    setSubject(tplSubject);

    // CUERPO MENSAJE
    let tplBody =
      emailSettings.plantilla_factura ||
      "Adjuntamos su factura en PDF.";

    tplBody = tplBody
      .replace(/{{NUMERO}}/g, numero)
      .replace(/{{EMPRESA}}/g, empresaNombre);

    const finalBody =
      tplBody +
      "\n\n" +
      (emailSettings.firma || "");

    setBody(finalBody);
  }, [factura, empresa, emailSettings]);

  if (!isOpen || !factura) return null;

  return (
    <div className="email-modal-overlay">
      <div className="email-modal-container">

        <h2 className="email-title">Enviar Factura por Email</h2>

        {/* PARA */}
        <label className="email-label">Para:</label>
        <input
          className="email-input"
          type="text"
          value={to}
          placeholder="correo1@example.com, correo2@example.com"
          onChange={(e) => setTo(e.target.value)}
        />

        {/* CC */}
        <label className="email-label">CC:</label>
        <input
          className="email-input"
          type="text"
          value={cc}
          placeholder="Opcional"
          onChange={(e) => setCc(e.target.value)}
        />

        {/* CCO */}
        <label className="email-label">CCO:</label>
        <input
          className="email-input"
          type="text"
          value={bcc}
          placeholder="Opcional"
          onChange={(e) => setBcc(e.target.value)}
        />

        {/* ASUNTO */}
        <label className="email-label">Asunto:</label>
        <input
          className="email-input"
          type="text"
          value={subject}
          onChange={(e) => setSubject(e.target.value)}
        />

        {/* MENSAJE */}
        <label className="email-label">Mensaje:</label>
        <textarea
          className="email-textarea"
          rows="7"
          value={body}
          onChange={(e) => setBody(e.target.value)}
        />

        {/* INFORMACIÓN DEL ADJUNTO */}
        <div className="email-adjunto-box">
          <strong>Se adjuntará:</strong>{" "}
          {`Factura ${factura.numero || factura.id} en PDF`}
        </div>

        {/* NUEVO — CHECKBOX INCLUIR IBAN */}
        <div
          style={{
            marginTop: 10,
            marginBottom: 5,
            display: "flex",
            alignItems: "center",
            gap: 8,
          }}
        >
          <input
            type="checkbox"
            checked={incluirIBAN}
            onChange={(e) => setIncluirIBAN(e.target.checked)}
          />
          <label style={{ fontSize: 13, opacity: 0.9 }}>
            Incluir número de cuenta (IBAN) en el PDF
          </label>
        </div>

        {/* BOTONES */}
        <div className="email-buttons">

          {/* ✔ Checkbox queda a la izquierda de Cancelar (como pediste) */}
          <button className="email-btn-cancel" onClick={onClose}>
            Cancelar
          </button>

          <button
            className="email-btn-send"
            onClick={() =>
              onSend({
                to,
                cc,
                bcc,
                subject,
                body,
                incluirIBAN, // ← 🔵 enviamos el valor al backend
              })
            }
          >
            Enviar Email
          </button>

        </div>

      </div>
    </div>
  );
}
